import LoginForm from './LoginForm';
import AvWorkforceLogo from 'src/components/AvWorkforceLogo';

const Login = () => {
  return (
    <main className="min-h-screen w-full bg-gradient-to-b from-[#000000] to-[#E8BF21] flex items-center justify-center p-4">
      <div className="w-full max-w-md flex flex-col items-center justify-center h-screen space-y-4 sm:space-y-6 md:space-y-8">
        {/* Logo - Responsive sizing */}
        <div className="w-full flex justify-center flex-shrink-0">
          <div
            className="
              w-40
              sm:w-48
              md:w-56
              lg:w-64
              xl:w-72
              max-h-[20vh]
            "
            style={{ maxWidth: 'calc(20vh * 0.875 / 0.522)' }}
          >
            <AvWorkforceLogo width={288} height={172} responsive draggable={false} />
          </div>
        </div>

        {/* Login Form - Responsive sizing and scrollable */}
        <div
          className="
          w-full bg-white rounded-xl shadow-2xl
          p-4 sm:p-6 md:p-8
          max-h-[70vh] overflow-y-auto
          flex-shrink-0
        "
        >
          <LoginForm />
        </div>
      </div>
    </main>
  );
};

export default Login;
